module.exports = __webpack_public_path__ + "images/19ebf71bfa54623f9bce179b1397b1f4.png";